'use strict';

/* globals config, $, socket */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	var internals = {};
	var timer;

	Vue.component('course-viewer-panel', {
		props: ['initData'],
		data: function () {
			return {
				chapters: this.initData.chapters,
				trainers: this.initData.trainers,
				currentChapter: 0,
				isStarted: false,
				autoplay: true,
			};
		},
		computed: {
			chapter: function () {
				return this.chapters[this.currentChapter];
			},
			isStartPage: function () {
				return this.currentChapter === 0;
			},
			isLastChapter: function () {
				return this.currentChapter + 1 === this.chapters.length;
			},
		},
		mounted: function () {
			this.chapters.unshift({
				title: 'Trainers',
				isCollapsed: false,
			});
		},
		methods: {
			startMeasureTime: function () {
				var me = this;
				
				if (timer) clearInterval(timer);
				
				timer = window.setInterval(function() {
					socket.emit('plugins.coursesAnalytics.addWebinarTimeSpent', { courseId: me.initData.course.courseId, uuid: me.initData.uuid, chapter: me.currentChapter, groupName: me.initData.group.name });
				}, 10000);	
			},
			start: function () {

			},
			openChapter: function (index) {
				
				socket.emit('plugins.coursesAnalytics.closedChapter', { courseId: this.initData.course.courseId, uuid: this.initData.uuid, chapter: this.currentChapter, groupName: this.initData.group.name });

				this.currentChapter = index;

				socket.emit('plugins.coursesAnalytics.openedChapter', { courseId: this.initData.course.courseId, uuid: this.initData.uuid, chapter: index, groupName: this.initData.group.name });
			},
			goToNextChapter: function () {
				if (this.currentChapter + 1 === this.chapters.length) {
					socket.emit('plugins.coursesAnalytics.finishedCourse', { courseId: this.initData.course.courseId, uuid: this.initData.uuid, groupName: this.initData.group.name });

					return;
				}

				this.openChapter(this.currentChapter + 1);
			},
			goToPrevChapter: function () {
				this.openChapter(this.currentChapter - 1);
			},
			startCourse: function () {
				if (this.currentChapter === 0) {
					this.goToNextChapter();
				} else {
					this.openChapter(1);
				}

				this.saveAttempt();	
			},
			saveAttempt: function () {
				var me = this;

				if (this.isStarted) {
					return;
				}
				
				this.isStarted = true;

				socket.emit('plugins.coursesAnalytics.startedCourse', { courseId: this.initData.course.courseId, uuid: this.initData.uuid, groupName: this.initData.group.name }, function () {
					me.startMeasureTime();
				});
			}
		},
		template:
		'<div>' +
			'<div class="col-md-3">' +
				'<div class="card">' +
					'<div class="card-header ch-alt" :style="{ backgroundColor: this.initData.group.groupColor }">' +
						'Chapters' +
					'</div>' +
					'<div class="card-body">' +
						'<course-chapters :init-data="initData" :open-chapter="openChapter" :current-chapter="currentChapter"></course-chapters>' +
					'</div>' +
				'</div>' +
				'<div class="card">' +
					'<div class="card-header ch-alt" :style="{ backgroundColor: this.initData.group.groupColor }">' +
						'Files' +
					'</div>' +
					'<div class="card-body">' +
						'<course-files :init-data="initData"></course-files>' +
					'</div>' +
				'</div>' +
			'</div>' +
			'<div class="col-md-9">' +
				'<div class="card">' +
					'<div class="card-header ch-alt chapter-header" :style="{ backgroundColor: this.initData.group.groupColor }">' +
						'<div>Chapter {{chapter.title}}</div>' +
						'<div class="autoplay">' +
							'<input type="checkbox" id="autoplay" name="autoplay" v-model="autoplay">' +
							'<label for="autoplay">Autoplay</label>' +
						'</div>' +
					'</div>' +
					'<div class="card-body">' +
						'<course-start v-if="isStartPage" :init-data="initData" :trainers="trainers"></course-start>' +
						'<course-chapter v-if="!isStartPage" :init-data="initData" :save-attempt="saveAttempt" :current-chapter="currentChapter" :chapter="chapter" :is-last-chapter="isLastChapter" :go-to-next-chapter="goToNextChapter" :is-started="isStarted" :autoplay="autoplay"></course-chapter>' +
						'<div class="nav-buttons">' +
							'<button class="btn btn-primary" v-if="isStarted" :disabled="!chapters[currentChapter - 1]" v-on:click="goToPrevChapter()"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>' +
							'<button class="btn btn-primary" v-if="isStarted" :disabled="!chapters[currentChapter + 1]" v-on:click="goToNextChapter()"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>' +
							'<button class="btn btn-primary" v-if="!isStarted" v-on:click="startCourse()">{{initData.translations.startCourse}}</button>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>' +
		'</div>',
	});

	internals.expandChapter = function (chapter) {
		setTimeout(function () {
			$('[data-toggle="collapse"]', chapter.el).click();
		}, 150);
	};
});
